import { useEffect, useState } from "react";

export const useWindowWidth = () => {
  const [width, setWidth] = useState(typeof window === "undefined" ? 1280 : window.innerWidth);
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return width;
};

const BREAKPOINTS = { base: 0, sm: 640, md: 768, lg: 1024, xl: 1280, "2xl": 1536, "3xl": 1920, "4xl": 2560 };

export const resolveResponsive = (value, width) => {
  if (typeof value !== "object" || value === null) return value;
  let result = value.base;
  for (const [key, min] of Object.entries(BREAKPOINTS)) {
    if (width >= min && value[key] != null) result = value[key];
  }
  return result;
};
